import React, { useState } from 'react';

const LOGO_SRC = '/assets/logo/wassla-logo.png';

/**
 * WasslaLogo — responsive sizing for web.
 * "header": 38px tall, ~132px wide (responsive)
 * "auth":   64px tall, ~220px wide
 * "footer": 44px tall, ~150px wide
 * "small":  28px tall, ~96px wide
 */
export default function WasslaLogo({ size = 'header', className = '', alt = 'Wassla', style = {} }) {
  const [error, setError] = useState(false);

  const screenW = typeof window !== 'undefined' ? window.innerWidth : 390;

  const SIZES = {
    small:  { height: 28, width: 96 },
    header: { height: 34, width: 118 },
    headerLarge: { height: 40, width: 140 },
    auth:   { height: 80, width: 260 },
    footer: { height: 55, width: 180 },
  };

  const s = SIZES[size] || SIZES.header;

  if (error) {
    return (
      <span
        className={`wasslaLogoFallback ${className}`}
        style={{ fontSize: s.height * 0.5, fontWeight: 900, color: '#1F6F3A', lineHeight: 1, ...style }}
      >
        Wassla
      </span>
    );
  }

  return (
    <img
      src={LOGO_SRC}
      alt={alt}
      className={`wasslaLogo ${className}`}
      style={{
        height: s.height,
        width: s.width,
        objectFit: 'contain',
        display: 'block',
        ...style,
      }}
      draggable={false}
      onError={() => setError(true)}
    />
  );
}
